import { assertNever } from '@kofno/piper';
import { action, observable, makeObservable } from 'mobx';

import { State, waiting, copying, copied } from './Types';

class CopyToClipboardStore {
  @observable
  state: State;
  readonly text: string;

  constructor(text: string) {
    makeObservable(this);
    this.state = waiting();
    this.text = text;
  }

  @action
  waiting = () => {
    switch (this.state.kind) {
      case 'copied':
        this.state = waiting();
        break;
      case 'waiting':
      case 'copying':
        break;
      default:
        assertNever(this.state);
    }
  };

  @action
  copying = () => {
    switch (this.state.kind) {
      case 'waiting':
        this.state = copying();
        break;
      case 'copied':
      case 'copying':
        break;
      default:
        assertNever(this.state);
    }
  };

  @action
  copied = () => {
    switch (this.state.kind) {
      case 'copying':
        this.state = copied();
        break;
      case 'waiting':
      case 'copied':
        break;
      default:
        assertNever(this.state);
    }
  };
}

export default CopyToClipboardStore;
